<template>
  <el-popover placement="bottom" width="80" trigger="hover">
    <div v-for="(item,index) in list" :key="index" @click="seleteChange(item.value)" class="select-type">
      <span style="">{{item.label}}</span>
      <i
        class="el-icon-check"
        v-if="nowValue==item.value"
        style="color: rgb(199, 0, 10) !important;font-size:12px;line-height:30px"
      ></i>
    </div>
    <span slot="reference">
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
  </el-popover>
</template>
 
<script>
export default {
  data() {
    return {
      nowValue: "",
      value: "",
      show: true,
      list: [
        { label: "全部", value: "" },
        { label: "启用", value: "1" },
        { label: "禁用", value: "0" }
      ]
    };
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [
          { label: "全部", value: "全部" },
          { label: "未排课", value: "1" },
          { label: "开课中", value: "4" }
        ];
      }
    }
  },
  watch: {
    defaultValue(newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  methods: {
    seleteChange(value) {
      this.nowValue = value;
      this.$emit("selectChange", value);
    }
  }
};
</script>
<style scoped>
.select-type{
  display: flex;
  justify-content: space-between;
  line-height: 30px;
  cursor: pointer;
  font-size: 14px;
}
.el-popover {
  width: 80px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/agentInfo/SelectHeader.vue